import { ErrorHandler, inject, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { AppVersionReloadService } from './app-version-reload.service';

@Injectable()
export class ChunkLoadErrorHandler implements ErrorHandler {
  private readonly appVersionReload = inject(AppVersionReloadService);

  handleError(error: unknown): void {
    if (this.appVersionReload.isChunkLoadError(error)) {
      this.appVersionReload.handleChunkLoadError(error);
      return;
    }

    console.error(error);
    Sentry.captureException(error);
  }
}
